import { Component } from "@angular/core"
import { ModalController } from "ionic-angular"

import { NotificationsSettingsPage } from "./notifications"
import { CalendarSettingsPage } from "./calendar"
import { ProfilePasswordPage } from "../profile/password"

@Component({
  selector: "settings-page",
  templateUrl: "index.html",
})
export class SettingsPage {

  notificationsPage: any = NotificationsSettingsPage
  calendarPage: any = CalendarSettingsPage

  constructor(
    private modalCtrl: ModalController
  ) {}

  onShowPasswordPage() {

    this.modalCtrl.create(ProfilePasswordPage).present()
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/index.ts